import React from 'react';

function Footer(props) {
    return (
        <div className="footer">
            <p>&lt;/&gt; with ❤️</p>
        </div>
    );
}

export default Footer;